const importAllReducers = (r) => {
  const reducers = {}

  r.keys().forEach((key) => {
    const { reducer, name } = r(key)

    if (!name) {
      return
    }

    reducers[name] = reducer
  })

  return reducers
}

const importAllServices = (r) => {
  const reducers = {}
  const middlewares = []

  r.keys().forEach((key) => {
    const api = r(key).default

    if (!api) {
      return
    }

    reducers[api.reducerPath] = api.reducer
    middlewares.push(api.middleware)
  })

  return {
    reducers,
    middlewares
  }
}

export const getReducers = () => {
  return importAllReducers(require.context('./slices', false, /\.js$/))
}

export const getServices = () => {
  const allReducers = {}
  const allMiddlewares = []

  const deepServices = importAllServices(require.context('./', true, /\.service.js$/))
  Object.assign(allReducers, deepServices.reducers)
  allMiddlewares.push(...deepServices.middlewares)

  const directServices = importAllServices(require.context('./services', false, /\.js$/))
  Object.assign(allReducers, directServices.reducers)
  allMiddlewares.push(...directServices.middlewares)

  return {
    reducers: allReducers,
    middlewares: allMiddlewares
  }
}

export default {
  getReducers,
  getServices
}
